<template>
  <div class="bg">
    <div class="container" :class="{mode: mode}">
    <BasicBar v-if="showBasic" @moon="mode =! mode"></BasicBar>
    <quill-editor 
      v-model="content" 
      ref="myQuillEditor" 
      :options="editorOption" 
      @blur="onEditorBlur($event)" 
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
      @ready="onEditReady($event)"
      v-else >
      </quill-editor>
    <router-view/>
    </div>
  </div>
</template>

<style lang="sass">
@import './assets/css/all.sass'
</style>

<script>
import BasicBar from '@/components/BasicBar.vue'
import EditBar from '@/components/EditBar.vue'
export default {
  data() {
    return {
      showBasic: true,
      content: '',
      mode: false,
      editorOption: false
    }
  },
  components: {
    BasicBar,
    EditBar
  },
  computed: {
    editor() {
        return this.$refs.myTextEditor.quill
      }
  },
  methods: {
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange(quill) {
      console.log("editor change!", quill);
    },
    saveHtml(event){
          alert(this.content);
        }
  },
  watch: {
    '$route.path': function (newVal, oldVal) {
    if (newVal === '/Note') {
      this.showBasic = false
    }else{
      this.showBasic = true
    }
  }
  },
  created() {
    console.log("mode", this.mode)
  }
}
</script>

